<template>
  <div class="ruleSetting-box">
    <!-- 按钮组： 添加级别/删除级别 -->
    <div class="ruleLevel-btn-box" :style="version == '0' ? 'visibility:hidden;' : ''">
      <div class="pull-right">
        <button class="btn btn-style-add" @click="addLevel" :disabled="!enableUpperCalc || version == '0'">
          <span class="glyphicon glyphicon-plus"></span>
          {{multiLanguage.btnGroup.addLevel}}
        </button>
        <button class="btn btn-style-remove" @click="removeLevel" :disabled="!enableUpperCalc || version == '0'">
          <span class="glyphicon glyphicon-trash"></span>
          {{multiLanguage.btnGroup.removeLevel}}
        </button>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 规则设定主体内容： 外层包裹拖拽组件 draggable-->
    <draggable :list="rule" :options="{group:'levelGroup',disabled: onfocus}" @start="drag=true" @end="drag=false">
      <!-- 过渡动画组件 transition-group -->
      <transition-group type="transition" :name="'flip-list'">
        <!-- 规则主体内容： -->
        <div class="rule-content-box panel panel-default" v-for="(levelItem,levelIndex) in rule" :key="levelIndex+levelItem" :class="{'disabled' : !enableUpperCalc || version == '0'}">
          <!-- 头部 -->
          <div class="panel-heading title-bg">
            <!-- 大标题：级别1-级别n -->
            <div class="panel-title">
              <!-- 左边：复选框、几级代理 -->
              <div class="pull-left">
                <label>
                  <input type="checkbox" :disabled="!enableUpperCalc || version == '0'" v-model="checkedLevel" :value="levelIndex" v-if="levelIndex !== rule.length-1">
                  <span class="primary-color">
                    {{levelIndex == rule.length-1 ? ruleSettingLan.currentIB : levelIndex+1 + ruleSettingLan.levelIB}}
                    <!--<span v-if="levelIndex == rule.length-1">
                      ({{currentIB.id + '-' + currentIB.name}})
                    </span>
                    <span v-else>
                      ({{ relation[levelIndex] ? relation[levelIndex].id + '-' + relation[levelIndex].name : ruleSettingLan.notExist }})
                    </span>-->
                  </span>
                </label>
              </div>
              <!-- 右边：添加规则按钮 -->
              <div class="pull-right" :style="version == '0' ? 'visibility:hidden;' : ''">
                <button class="btn btn-style-add" :disabled="!enableUpperCalc || version == '0'" @click="addRule(levelItem)">
                  <span class="glyphicon glyphicon-plus"></span>
                  {{ruleSettingLan.addRule}}
                </button>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <!-- 身体： 外层包裹拖拽组件 draggable-->
          <draggable :list="levelItem" :options="{group:'ruleGroup',disabled: onfocus}">
            <!-- 过渡动画 -->
            <transition-group type="transition" :name="'flip-list'">
              <!-- 身体内容 -->
              <div class="panel-body" v-for="(ruleItem,ruleIndex) in levelItem" :key="ruleIndex+ruleItem">
                <!-- 小标题: 规则1-规则n -->
                <div class="rule-title">
                  <!-- 左：规则n -->
                  <div class="pull-left primary-color">{{ruleSettingLan.rule}}{{ruleIndex+1}}</div>
                  <!-- 右：删除规则按钮 -->
                  <div class="pull-right" :style="version == '0' ? 'visibility:hidden;' : ''">
                    <button class="btn btn-xs" :disabled="!enableUpperCalc || version == '0'" @click="removeRule(levelItem,ruleIndex)">
                      <span class="glyphicon glyphicon-trash"></span>
                    </button>
                  </div>
                  <div class="clear"></div>
                </div>
                <!-- 身体主体内容 -->
                <div class="rule-content">
                  <!-- 第一行： 产品 -->
                  <div class="form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-1 control-label" >
                        {{ruleSettingLan.product}}
                      </label>
                      <div :class="{'col-sm-11': viewBtn == 'double', 'col-sm-5' : viewBtn == 'onlyOne' }">
                        <select class="form-control" v-model="ruleItem.productGroup" :disabled="!enableUpperCalc || version == '0'">
                          <option value="ALL">{{ruleSettingLan.ALL}}</option>
                          <option v-for="(productItem,productIndex) in groupSeq" :key="productIndex+productItem" :value="productItem">{{publicLan.products[productItem]}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- 第二行： 指定分配的账号 -->
                  <div class="form-horizontal">
                    <div class="form-group">
                      <div :class="{'col-sm-5' : viewBtn == 'double','col-sm-3' : viewBtn == 'onlyOne'}">
                        <label class="radio-inline">
                          <input type="radio" :name="version+'_'+levelIndex+'_'+ruleIndex+'_'+'enableCommTarget'"
                            :disabled="!enableUpperCalc || version == '0'"
                            :value="false"
                            v-model="ruleItem.enableCommTarget"
                          > 
                          {{ruleSettingLan.toOriginalAccount}}
                        </label>
                        <label class="radio-inline">
                          <input type="radio" :name="version+'_'+levelIndex+'_'+ruleIndex+'_'+'enableCommTarget'"
                            :disabled="!enableUpperCalc || version == '0'"
                            :value="true"
                            v-model="ruleItem.enableCommTarget"
                          > 
                          {{ruleSettingLan.toTargetAccount}}
                        </label>
                      </div>
                      <label :class="{'col-sm-7' : viewBtn == 'double','col-sm-3' : viewBtn == 'onlyOne'}">
                        <input type="text" class="form-control" v-model="ruleItem.commTarget" 
                          :disabled="!enableUpperCalc || version == '0' || !ruleItem.enableCommTarget"
                          v-validate="'required|numeric'" 
                          :name="levelIndex+'_'+ruleIndex+'_'+'commTarget'"
                          :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'commTarget') ? 'border-color:#f44336;' : ''"
                          @focus="onfocus=true" @blur="onfocus=false"
                          @change="!errors.has(levelIndex+'_'+ruleIndex+'_'+'commTarget') && checkId(ruleItem)"
                        >
                      </label>
                    </div>
                  </div>
                  <!-- 第三行： 按佣金收取 还是 自定金额  加点 -->
                  <div class="form-inline">
                    <!-- 按佣金 -->
                    <div :class="{'row' :viewBtn=='onlyOne'}">
                      <div class="has-feedback tips-wrap margin-bottom flex-box" :class="{'col-sm-6':viewBtn=='onlyOne'}">
                        <label class="radio-inline flex-item-left">
                          <input type="radio" :name="version+'_'+levelIndex+'_'+ruleIndex+'_'+'ruleId'"
                            :disabled="!enableUpperCalc || version == '0'"
                            :value="0"
                            v-model="ruleItem.ruleGroup"
                            @change="selectRuleFn(ruleItem)"
                          > 
                          {{ruleSettingLan.ruleIdGroup[0]}}
                        </label>
                        <div class="input-group flex-item-right">
                          <div class="input-group">
                            <select class="form-control" :disabled="!enableUpperCalc || version == '0' || ruleItem.ruleGroup !== 0"
                              v-model="ruleItem.ruleId"
                              v-validate="'required'" 
                              :name="levelIndex+'_'+ruleIndex+'_'+'ruleId'"
                              :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'ruleId') ? 'border-color:#f44336;' : ''"
                            >
                              <!-- <option value="0"></option> -->
                              <option :value="ruleSeqItem.ruleId" v-for="(ruleSeqItem,ruleSeqIndex) in ruleSeq" :key="ruleSeqIndex+ruleSeqItem"
                                v-if="ruleSeqItem.group === 0"  
                              >
                                {{publicLan.rule[ruleSeqItem.langKey.split('.')[1]]}}
                              </option>
                            </select>
                            <span class="input-group-addon">
                              <el-tooltip class="item" effect="dark" placement="top-start"
                                :disabled="!enableUpperCalc || version == '0' || ruleItem.ruleGroup !== 0"
                              >
                                <span class="glyphicon glyphicon-tags"></span>
                                <div slot="content" style="width: 180px;line-height:20px;" v-for="(ruleSeqItem,ruleSeqIndex) in ruleSeq" v-if="ruleSeqItem.ruleId === ruleItem.ruleId">
                                    {{ publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]] }}
                                </div>
                              </el-tooltip>
                            </span>
                          </div>
                          <div class="input-group">
                            <input type="text" class="form-control" style="border-radius:3px" 
                              :disabled="!enableUpperCalc || version == '0' || ruleItem.ruleGroup !== 0"
                              v-model="ruleItem.value"
                              v-if="ruleItem.ruleGroup == 0"
                              v-validate="'required|min_value:0.00|decimal:4'" 
                              :name="levelIndex+'_'+ruleIndex+'_'+'value1'"
                              :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'value1') ? 'border-color:#f44336;' : ''"
                              @focus="onfocus=true" @blur="onfocus=false"
                            >
                            <input type="text" class="form-control" style="border-radius:3px" v-else disabled>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 自定金额 -->
                    <div :class="{'row' :viewBtn=='onlyOne'}">
                      <div class="has-feedback margin-bottom flex-box" :class="{'col-sm-6':viewBtn=='onlyOne'}">
                        <label class="radio-inline flex-item-left">
                          <input type="radio" :name="version+'_'+levelIndex+'_'+ruleIndex+'_'+'ruleId'"
                            :disabled="!enableUpperCalc || version == '0'"
                            :value="1"
                            v-model="ruleItem.ruleGroup"
                            @change="selectRuleFn(ruleItem)"
                          > 
                          {{ruleSettingLan.ruleIdGroup[1]}}
                        </label>
                        <div class="input-group flex-item-right">
                          <div class="input-group">
                            <select class="form-control" :disabled="!enableUpperCalc || version == '0' || ruleItem.ruleGroup !== 1"
                              v-model="ruleItem.ruleId"
                              v-validate="'required'" 
                              :name="levelIndex+'_'+ruleIndex+'_'+'ruleId'"
                              :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'ruleId') ? 'border-color:#f44336;' : ''"
                              @change="selectRule6Fn(ruleItem)"
                            >
                              <!-- <option value="0"></option> -->
                              <option :value="ruleSeqItem.ruleId" v-for="(ruleSeqItem,ruleSeqIndex) in ruleSeq" :key="ruleSeqIndex+ruleSeqItem"
                                v-if="ruleSeqItem.group == 1"  
                              >
                                {{publicLan.rule[ruleSeqItem.langKey.split('.')[1]]}}
                              </option>
                            </select>
                            <span class="input-group-addon" >
                              <el-tooltip class="item" effect="dark" placement="top-start" 
                                :disabled="!enableUpperCalc || version == '0' || ruleItem.ruleGroup !== 1"
                              >
                                <span class="glyphicon glyphicon-tags"></span>
                                <div slot="content" style="width: 180px;line-height:20px;" v-for="(ruleSeqItem,ruleSeqIndex) in ruleSeq" v-if="ruleSeqItem.ruleId === ruleItem.ruleId">
                                    {{ publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]] }}
                                </div>
                              </el-tooltip>
                            </span>
                          </div>
                          <div class="input-group">
                            <input type="text" class="form-control" style="border-radius:3px" 
                              :disabled="!enableUpperCalc || version == '0' || ruleItem.ruleGroup !== 1"
                              v-model="ruleItem.value"
                              v-if="ruleItem.ruleGroup == 1 && ruleItem.ruleId != 6"
                              v-validate="'required|min_value:0.00|decimal:4'" 
                              :name="levelIndex+'_'+ruleIndex+'_'+'value2'"
                              :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'value2') ? 'border-color:#f44336;' : ''"
                              @focus="onfocus=true" @blur="onfocus=false"
                            >
                            <input type="text" class="form-control" style="border-radius:3px" v-else disabled>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 加点 外佣 内返 -->
                    <div :class="{'row' :viewBtn=='onlyOne'}">
                      <div class="has-feedback margin-bottom " :class="{'col-sm-6':viewBtn=='onlyOne'}">
                        <label class="radio-inline" style="padding-left:0;" :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'spreadEnable') ? 'color:#f44336;' : ''">
                          <input type="checkbox" 
                            :disabled="!enableUpperCalc || version == '0' || ruleItem.ruleGroup !== 0"
                            v-model="ruleItem.spreadEnable"
                            v-validate="!ruleItem.externalCommissionEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''" 
                            :name="levelIndex+'_'+ruleIndex+'_'+'spreadEnable'"
                          > 
                          {{ruleSettingLan.spreadCommission}}
                        </label>
                        <label class="radio-inline" :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'externalCommissionEnable') ? 'color:#f44336;' : ''">
                          <input type="checkbox"
                            :disabled="!enableUpperCalc || version == '0' || ruleItem.ruleGroup !== 0"
                            v-model="ruleItem.externalCommissionEnable"
                            v-validate="!ruleItem.spreadEnable && !ruleItem.internalCommissionEnable ? 'required:true' : ''" 
                            :name="levelIndex+'_'+ruleIndex+'_'+'externalCommissionEnable'"
                          > 
                          {{ruleSettingLan.externalCommission}}
                        </label>
                        <label class="radio-inline" :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'internalCommissionEnable') ? 'color:#f44336;' : ''">
                          <input type="checkbox"
                            :disabled="!enableUpperCalc || version == '0' || ruleItem.ruleGroup !== 0"
                            v-model="ruleItem.internalCommissionEnable"
                            v-validate="!ruleItem.externalCommissionEnable && !ruleItem.spreadEnable ? 'required:true' : ''" 
                            :name="levelIndex+'_'+ruleIndex+'_'+'internalCommissionEnable'"
                          > 
                          {{ruleSettingLan.internalCommission}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    components: {
      draggable,
    },
    props: {
      multiLanguage: {
        type: Object,
        default: {},
      },
      groupSeq: {
        type: Array,
        default: [],
      },
      enableUpperCalc: {
        type: Boolean,
        default: false,
      },
      version: {
        type: String,
        default: ''
      },
      relation: {
        type: Array,
        default: [],
      },
      rule: {
        type: Array,
        default: [],
      },
      ruleSeq: {
        type: Array,
        default: [],
      },
      viewBtn: {
        type: String,
        default: ''
      },
      currentIB: {
        type: Object,
        default: {}
      }
    },
    mixins: [
      require("common/mixin/base.js").base({ruleSettingLan:"ibCommissionRuleSetting"}),
      require("common/mixin/base.js").base({publicLan:"publicLan"})
    ],
    data () {
      return {
        drag: null,
        ruleGroup: '',
        checkedLevel: [],
        onfocus: false,
      }
    },
    methods: {
      addLevel () {// 添加级别
        this.rule.splice(this.rule.length-1,0,[
          {
            commTarget:null,
            enableCommTarget:false,
            externalCommissionEnable:false,
            internalCommissionEnable:false,
            productGroup:'ALL',
            ruleGroup:0,
            ruleId:1,
            spreadEnable:false,
            value:""
          }
        ])
      },
      removeLevel () {// 删除级别
        if (this.checkedLevel.length > 0 ) {
          let msg = this.multiLanguage.btnGroup.confirmDeleteText
          if (confirm(msg) == true) {
            if (this.rule.length - this.checkedLevel.length >= 1) {
              let tem = this.rule.concat([])
              this.checkedLevel.forEach(item => {
                delete tem[item]
              })
              this.$parent.rule = tem.filter(item => item != null)
              this.checkedLevel = []
            }
            else return
          }
        }
        else return
      },
      addRule (levelItem) {// 添加规则
        levelItem.push({
            commTarget:null,
            enableCommTarget:false,
            externalCommissionEnable:false,
            internalCommissionEnable:false,
            productGroup:'ALL',
            ruleGroup:0,
            ruleId:1,
            spreadEnable:false,
            value:""
          })
      },
      removeRule (levelItem,ruleIndex) {// 删除规则
        let msg = this.multiLanguage.btnGroup.confirmDeleteText
        if (confirm(msg) == true) {
          levelItem.splice(ruleIndex,1)
        }
      },
      selectRuleFn (ruleItem) { // 切换 单选按钮： 按佣金还是自定金额。 如果是自定金额就將 加点 外佣 内返 这个3个复习按钮 全部禁用且改为 未选中
        if (ruleItem.ruleGroup == 1) {
          ruleItem.spreadEnable = false    
          ruleItem.externalCommissionEnable = false
          ruleItem.internalCommissionEnable = false
        }
        ruleItem.value = ''
      },
      selectRule6Fn (ruleItem) { //切换 选择器方法： 如果选择的是rule6 就將value清空
        ruleItem.ruleId == 6 ? ruleItem.value = '' : null
      },
      checkId (ruleItem) {
        this.$emit('checkId',ruleItem)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .ruleSetting-box {
    .ruleLevel-btn-box{
      margin: 10px 0;
    }
    .glyphicon{
      font-size: 12px;
    }
    input[type='checkbox'] {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-top: 0;
    }
    .rule-content-box{
      margin-bottom: 10px;
      .panel-title{
        height: 36px;
        line-height: 36px;
      }
      .panel-body{
        padding: 0;
        .rule-title{
          border-bottom: 1px solid #bbb;
          padding: 10px 20px;
          line-height: 30px;
          button{
            background: transparent;
            span{
              color: #f08712;
            }
          }
          
        }
        .rule-content{
          padding: 10px 20px 0;
          .flex-box{
            display: flex;
            .flex-item-left{
              width: 20%;
              margin-top: 8px;
            }
            .flex-item-right{
              width: 80%;
              text-align: right;
              .input-group{
                width: 49%;
              }
              .input-group:last-child{
                margin-left: 1%;
              }
            }
          }
          .tips-wrap{
            position: relative;
            .tips-box{
              width: 120px;
              line-height: 30px;
              background: #000;
              color: #fff;
              border-radius: 3px;
              z-index: 999;
            }
          }
          
        }
      }
    }
    .btn-style-add {
      background-color: #3f51b5;
      color:#fff;
    }
    .btn-style-remove {
      background-color:#f08712;
      color:#fff;
    }
    .primary-color{
      color: #3f51b5;
    }
    .title-bg{
      background-color: #EBEDF7;
    }
    .margin-left-lg{
      margin-left: 40px;
    }
    .margin-bottom{
      margin-bottom: 20px;
    }
  }
  .input-group-addon{
    width: 1%!important;
  }
</style>



// WEBPACK FOOTER //
// ruleSetting.vue?65363e36